module.exports = __webpack_public_path__ + "images/bb6328e0309fd803f1a0b55495abc1ff.svg";